var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 5.2C2.66675 4.0799 2.66675 3.51984 2.88473 3.09202C3.07648 2.71569 3.38244 2.40973 3.75877 2.21799C4.18659 2 4.74664 2 5.86675 2H10.1334C11.2535 2 11.8136 2 12.2414 2.21799C12.6177 2.40973 12.9237 2.71569 13.1154 3.09202C13.3334 3.51984 13.3334 4.0799 13.3334 5.2V14L11.5001 12.6667L9.83341 14L8.00008 12.6667L6.16675 14L4.50008 12.6667L2.66675 14V5.2Z",
    stroke: "#424242",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptIcon);
export default __webpack_public_path__ + "static/media/receipt-icon.055fa307bfb9b7b9ad44354940d69326.svg";
export { ForwardRef as ReactComponent };